import React, {useState} from "react";
import Icon from 'components/Safra/Icon';

import Button from 'components/Button'
import {FixedRating} from "components/Rating";
import {useNavigate} from "react-router-dom";
import {formatCurrency} from 'utils/functions'
import {
    ContainerHotel,
    ContainerPrice,
    ContentHotel,
    HotelImages,
    InformationHotel
} from "./styles";

import {useApp} from "../../../contexts/AppContext";
import {changeSelectedHotelAction, changeSelectedRoomHotelAction} from "../../../contexts/reducers/hotels/actions";
import {isChannel} from "../../../utils";
import {useGenialApp} from "../../../contexts/GenialAppContext";
import { subDays, isAfter, format } from 'date-fns';
import { trackHotelSelectHotel } from '../../../utils/analytics';
import { useTranslation } from "contexts/Safra/TranslationContext";

export const BoxHotel = ({data}) => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [imageError, setImageError] = useState(false);


    const { hotelState, hotelDispatch } =  !isChannel('genial') ? useApp() : useGenialApp()
    const { offersHotel, travellers, datesSearchHotel } = hotelState

    const room = data.rooms[0]?.name;
    const price = data.rooms[0]?.amount?.BRL
    const points = data.rooms[0]?.amount?.points
    const board = data.rooms[0]?.board?.name

    const externalProperties = JSON.parse(data?.rooms[0]?.externalProperties)

    const getBoardTag = (boardName) => {
        if (!boardName) return null;

        const normalizedBoard = boardName.toLowerCase().replace(/\s+/g, '_');
        
        if (normalizedBoard === 'not_included') return null;

        const boards = {
            'all_inclusive': { text: t('safra.hotel_page.room.boards.all_inclusive'), className: "included", icon: <Icon name="cup-soda" /> },
            'breakfast': { text: t('safra.hotel_page.room.boards.breakfast'), className: "included", icon: <Icon name="coffee" /> },
            'full_board': { text: t('safra.hotel_page.room.boards.full_board'), className: "included", icon: <Icon name="hand-platter" /> },
            'half_board': { text: t('safra.hotel_page.room.boards.half_board'), className: "included", icon: <Icon name="hand-platter" /> }
        };

        return boards[normalizedBoard] || null;
    };

    const getCancellationTag = () => {
        if (!data.rooms || data.rooms.length === 0) return { 
            text: t('safra.hotel_page.room.cancellation.non_refundable'), 
            className: "non-refundable", 
            icon: <Icon name="x" /> 
        };

        const today = new Date();
        const roomsStatus = data.rooms.map(room => {
            const resInfo = room.reservationInfo;
            
            const isIrrevocable = resInfo?.irrevocableGuarantee === true;
            
            const isNonRefundable = Array.isArray(resInfo?.cancellationPolicies) 
                ? resInfo.cancellationPolicies.some(policy => policy?.nonRefundable === true) : false;

            if (isIrrevocable || isNonRefundable) return false;

            const cancelDeadline = resInfo?.cancelDeadLineDateValues;
            if (!cancelDeadline) return false;

            const deadlineDate = new Date(
                cancelDeadline.year,
                cancelDeadline.month - 1,
                cancelDeadline.day,
                cancelDeadline.hour,
                cancelDeadline.minutes
            );

            const freeCancellationUntil = subDays(deadlineDate, 3);
            return isAfter(freeCancellationUntil, today);
        });

        const allFree = roomsStatus.every(status => status === true);
        const noneFree = roomsStatus.every(status => status === false);

        if (allFree) return { 
            text: t('safra.hotel_page.room.cancellation.free_simple'), 
            className: "free-cancellation", 
            icon: <Icon name="check" /> 
        };
        if (noneFree) return { 
            text: t('safra.hotel_page.room.cancellation.non_refundable'), 
            className: "non-refundable", 
            icon: <Icon name="x" /> 
        };
        return { 
            text: t('safra.components.box_hotel.cancellation_options'), 
            className: "partial-cancellation", 
            icon: <Icon name="check" /> 
        };
    };

    const handleSelectHotel = () => {
        trackHotelSelectHotel({
            location: `${data.address.street}, ${data.address.city}`,
            check_in: datesSearchHotel?.startDate ? format(datesSearchHotel.startDate, "dd/MM/yyyy") : '',
            check_out: datesSearchHotel?.endDate ? format(datesSearchHotel.endDate, "dd/MM/yyyy") : '',
            hotel_name: data.name,
            hosts: travellers?.length,
            nights: datesSearchHotel?.days,
            adults: travellers?.filter(t => t.type === 'adults').length,
            children: travellers?.filter(t => t.type === 'children').length,
            stars: data.stars
        });
        
        hotelDispatch(changeSelectedHotelAction(data))
        hotelDispatch(changeSelectedRoomHotelAction({}))

        navigate(`/hotel-page`)
    }

    const handleContinueClick = (event) => {
        event.stopPropagation();
        handleSelectHotel();
    }

    const handleImageError = () => {
        if (currentImageIndex < data.images.length - 1) {
            setCurrentImageIndex(currentImageIndex + 1);
        } else {
            setImageError(true);
        }
    };

    return (
        <ContainerHotel onClick={ handleSelectHotel } style={{ cursor: 'pointer' }}>
            <div className="d-flex">
                {!imageError && data.images && data.images.length > 0 && (
                    <div className="image">
                        <HotelImages
                            src={data.images[currentImageIndex]?.url}
                            alt={data.name}
                            onError={handleImageError}
                        />
                    </div>
                )}

                <InformationHotel>
                    <ContentHotel>
                        <p className="title-hotel">{ data.name }</p>
                        <div className="stars">
                            <FixedRating value={ data.stars } size="small" />
                        </div>

                        <div className="tags-container">
                            {(() => {
                                const boardTag = getBoardTag(board);
                                if (!boardTag) return null;
                                return (
                                    <p className={`info ${boardTag.className}`}>
                                        {boardTag.icon}
                                        <span>{boardTag.text}</span>
                                    </p>
                                );
                            })()}

                            {(() => {
                                const tag = getCancellationTag();
                                return (
                                     <p className={`info ${tag.className}`}>
                                         {tag.icon}
                                         <span>{tag.text}</span>
                                     </p>
                                 );
                            })()}
                        </div>
                        <p className="mapa">
                            {data.address.street}
                        </p>

                    </ContentHotel>
                    <ContainerPrice>
                        <p style={{fontWeight:700, marginBottom:"10px 0px" }}> { room } </p>
                        <p className="diaria">{t('safra.components.box_hotel.from_nightly')}</p>
                        { offersHotel === "cash" && <p className="price"> { formatCurrency(price) } </p> }
                        { offersHotel === "points" && <p className="price">{ parseFloat(points).toLocaleString() } <span>{t('safra.components.box_hotel.points')}</span></p> }

                        <p className="taxa">{t('safra.components.box_hotel.taxes_included')}</p>
                    </ContainerPrice>

                    <div className="text-center mt-2 mb-1">
                        <Button width="160px" onClick={ handleContinueClick }>{t('safra.common.continue').toUpperCase()}</Button>
                    </div>
                </InformationHotel>
            </div>
        </ContainerHotel>
    )
}
